import { C, DARK } from "./theme";

// The Nudge logo, white on the dark theme. Home's top bar, the sidebar and the sign-in screen draw it.
export function Logo({ height }) {
  return <img src={C.bg === DARK.bg ? "/nudge-logo-white-transparent.svg" : "/nudge-logo-transparent.svg"} alt="Nudge" style={{ height, display: "block" }} />;
}
